import {Alert} from 'src/design/atoms/Alert';
import React from 'react';
import {ContentTitle} from 'src/design/atoms/Typography';
import {FormField} from 'src/app/forms/FormField';
import {noYesOptions} from 'src/shared/constants/fieldTypeDictionary';
import type {IFormFieldV2} from 'src/types/FormV2';
import {
  useGetSelectedField,
  useUpdateSelectedField,
} from '../../../../hooks/useFormBuilder';
import {VisibilityRuleModal} from './components/VisibilityRuleModal';

const hideDefaultField: IFormFieldV2 = {
  name: 'isDefaultHidden',
  label: 'Hide Field by Default',
  type: 'select',
  options: noYesOptions,
};

export const VisibilityRuleSettings = React.memo(() => {
  const field = useGetSelectedField();
  const updateSelectedField = useUpdateSelectedField();

  const handleHideDefaultChange = React.useCallback(
    (name: string, value: string) => {
      if (!field) return;

      updateSelectedField({
        ...field,
        visibility: {
          ...field.visibility,
          isDefaultHidden: value === 'yes',
        },
      });
    },
    [field, updateSelectedField]
  );

  if (!field) return null;

  return (
    <>
      <ContentTitle text="Visibility Rules" />

      <FormField
        field={hideDefaultField}
        value={field?.visibility?.isDefaultHidden ? 'yes' : 'no'}
        onChange={handleHideDefaultChange}
      />

      {field?.visibility?.isDefaultHidden === true && (
        <Alert color="yellow" mb="md">
          <b>Note</b>: Because this field is hidden by default, it may only be
          seen by configuring a visibility rule.
        </Alert>
      )}

      <VisibilityRuleModal />
    </>
  );
});
